interface FavoriteButtonProps {
  active: boolean;
  onToggle: () => void;
  className?: string;
  size?: "sm" | "md";
}

export default function FavoriteButton({
  active,
  onToggle,
  className = "",
  size = "sm",
}: FavoriteButtonProps) {
  const box = size === "sm" ? "w-8 h-8" : "w-10 h-10";
  const icon = size === "sm" ? "text-base" : "text-xl";
  return (
    <button
      type="button"
      aria-label={active ? "取消收藏" : "加入收藏"}
      title={active ? "取消收藏" : "加入收藏"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
      className={`${box} flex items-center justify-center rounded-full border backdrop-blur-sm cursor-pointer transition-colors ${
        active
          ? "bg-accent-500 border-accent-500 text-background-50"
          : "bg-background-50/85 border-background-200 text-foreground-600 hover:text-accent-600 hover:border-accent-300"
      } ${className}`}
    >
      <i className={`${active ? "ri-heart-3-fill" : "ri-heart-3-line"} ${icon}`} />
    </button>
  );
}